import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "16",
  "aria-hidden": "true",
  viewBox: "0 0 21 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.64 5c.263 0 .504.15.618.387l1.381 2.842 3.087.455a.689.689 0 0 1 .382 1.169l-2.238 2.215.53 3.13a.691.691 0 0 1-1.003.721l-2.756-1.471-2.756 1.471a.69.69 0 0 1-1.003-.722l.528-3.13-2.238-2.214a.686.686 0 0 1 .382-1.169l3.085-.455 1.381-2.842A.69.69 0 0 1 14.64 5M2.25 10c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75a.75.75 0 0 1-.75-.75v-1.5c0-.416.334-.75.75-.75z" }, null, -1),
    _createElementVNode("path", { d: "m8.075 10.5 2.022 2H5.5a1 1 0 0 1-.993-.883L4.5 11.5a1 1 0 0 1 1-1zM2.25 5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75A.75.75 0 0 1 0 7.25v-1.5C0 5.334.334 5 .75 5zm10.585.5-.924 1.903-.664.097H5.5a1 1 0 0 1-.993-.883L4.5 6.5a1 1 0 0 1 1-1zM2.25 0c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75H.75A.75.75 0 0 1 0 2.25V.75C0 .334.334 0 .75 0zM14.5.5a.999.999 0 1 1 0 2h-9a.999.999 0 1 1 0-2z" }, null, -1)
  ])))
}
export default { render: render }